import React from 'react';

export function matchIsObject(value: unknown): value is object {
  return typeof value === 'object' && !Array.isArray(value) && value !== null;
}

export function assocRefToPropRef<T extends Element | null>(
  ref: T,
  propRef: React.Ref<T> | undefined
): void {
  if (typeof propRef === 'function') {
    propRef(ref);
  } else if (propRef && matchIsObject(propRef) && 'current' in propRef) {
    propRef.current = ref;
  }
}
